<div class="row">
    <div class="col d-none d-lg-block" *ngIf="!hideEventsComponent">
        <app-compact-upcoming-events [numEventsPerLoad]="4" (hideEvents)="hideEvents($event)"></app-compact-upcoming-events>
    </div>
    <div class="col d-none d-lg-block" *ngIf="!hideResturantMenuComponent">
        <app-compact-restaurant-menu (hideRestaurantMenu)="hideRestaurantMenu($event)"></app-compact-restaurant-menu>
    </div>
    <div class="col d-none d-lg-block"  *ngIf="!hideBirthdaysComponent">
        <app-compact-birthdays (hideBirthdays)="hideBirthdays($event)"></app-compact-birthdays>
    </div>
    <div class="col d-none d-lg-block" *ngIf="!hideRssComponent">
        <app-compact-rss-feeds (hideRssFeed)="hideRssFeed($event)"></app-compact-rss-feeds>
    </div> 
</div>

  <div class="row compact-layout-mobile pt-4 pb-4 d-block d-lg-none">
    <mat-accordion>
        <mat-expansion-panel [expanded]="true" class="pt-2 pb-2 col border-top" *ngIf="!hideEventsComponent">
            <mat-expansion-panel-header>
                <mat-panel-title class="bolder">
                    <h2 i18n="organization upcoming events header@@organization-upcoming-events-header" class="widget-header h4 my-news-title">Upcoming events</h2>
                </mat-panel-title>
            </mat-expansion-panel-header>
             <app-compact-upcoming-events [numEventsPerLoad]="4" (hideEvents)="hideEvents($event)"></app-compact-upcoming-events>
         </mat-expansion-panel>
      
        <mat-expansion-panel class="pt-2 pb-2 col" (opened)="panelOpenState = true" (closed)="panelOpenState = false" *ngIf="!hideResturantMenuComponent">
            <mat-expansion-panel-header>
                <mat-panel-title class="bolder">
                    <h2 i18n="@@restaurant-menu-header" class="widget-header h4 my-news-title">Restuarant menu</h2>
                </mat-panel-title>
            </mat-expansion-panel-header>
            <app-compact-restaurant-menu (hideRestaurantMenu)="hideRestaurantMenu($event)"></app-compact-restaurant-menu>
        </mat-expansion-panel>

        <mat-expansion-panel class="pt-2 pb-2 col" (opened)="panelOpenState = true" (closed)="panelOpenState = false" *ngIf="!hideBirthdaysComponent">
            <mat-expansion-panel-header>
                <mat-panel-title class="bolder">
                    <h2 i18n="birthdays header@@birthdays-header" class="widget-header h4 my-news-title">Birthday calendar</h2>
                </mat-panel-title>
            </mat-expansion-panel-header>
            <app-compact-birthdays (hideBirthdays)="hideBirthdays($event)"></app-compact-birthdays>
        </mat-expansion-panel>

        <mat-expansion-panel class="pt-2 pb-2 col" (opened)="panelOpenState = true" (closed)="panelOpenState = false" *ngIf="!hideRssComponent">
            <mat-expansion-panel-header>
                <mat-panel-title class="bolder">
                    <h2 i18n="rss feed header@@rss-feed-header" class="widget-header h4 my-news-title">Rss feed</h2>
                </mat-panel-title>
            </mat-expansion-panel-header>
            <app-compact-rss-feeds (hideRssFeed)="hideRssFeed($event)"></app-compact-rss-feeds>
        </mat-expansion-panel>
    </mat-accordion>
  </div>
  